import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../../hooks/useAuth';
import { useMobile } from '../../../hooks/useMobile';

import { ReactComponent as SettingsIcon } from '../../../icons/settings.svg';
import { ReactComponent as SignOutIcon } from '../../../icons/sign-out.svg';
import { ReactComponent as WalletIcon } from '../../../icons/wallet.svg';

import './navigation-popup.scss';

import { Button } from '../../common/button/Button';
import ThemeToggle from '../../theme-toggle/ThemeToggle';

const getInitials = (user) => {
  if (user?.displayName) {
    return user.displayName
      .split(' ')
      .map((n) => n[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }
  return user?.email?.[0]?.toUpperCase() ?? '?';
};

const NavigationPopup = ({ onSignOutClick }) => {
  const { user } = useAuth();
  const isMobile = useMobile();
  const navigate = useNavigate();
  const isLoggedIn = user && !user.isAnonymous;

  return (
    <div className="navigation-popup">
      <div>
        {isLoggedIn && (
          <>
            {user.photoURL ? (
              <img src={user.photoURL} width={40} height={40} alt="Profile" className="navigation-popup__avatar" />
            ) : (
              <div className="navigation-popup__initials">
                {getInitials(user)}
              </div>
            )}
            <div>
              <span>{user.displayName || 'User'}</span>
              <span>{user.email}</span>
            </div>
          </>
        )}
        {isMobile && (
          <div className="navigation-popup__theme-toggle">
            <ThemeToggle />
          </div>
        )}
      </div>
      {isLoggedIn ? (
        <>
          <span className="navigation-popup__divider" />
          <div className="navigation-popup__items">
            <NavigationPopupItem name="Settings" icon={SettingsIcon} />
            <NavigationPopupItem name="Wallet" icon={WalletIcon} />
          </div>
          <span className="navigation-popup__divider" />
          <NavigationPopupItem name="Sign Out" icon={SignOutIcon} onClick={onSignOutClick} />
        </>
      ) : (
        <div className="navigation-popup__sign-in">
          <Button
            onClick={() => navigate('/login')}
            style={{ background: '#e53935', borderColor: '#e53935' }}
          >
            Sign in
          </Button>
          <span>Access your orders and more</span>
        </div>
      )}
    </div>
  );
};

const NavigationPopupItem = ({ name, icon: Icon, onClick }) => {
  return (
    <div className="navigation-popup__item" onClick={onClick}>
      <span />
      <Icon />
      <span>{name}</span>
    </div>
  );
};

export default NavigationPopup;
